/* tslint:disable */
/* eslint-disable */
/**
 * PRTIMES Media User API
 * メディアユーザーマイページ用 API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    BusinessCategoryLv2,
    BusinessCategoryLv2FromJSON,
    BusinessCategoryLv2FromJSONTyped,
    BusinessCategoryLv2ToJSON,
} from './BusinessCategoryLv2';

/**
 * 
 * @export
 * @interface GetFollowingBusinessCategoriesLv2ResponseAllOfData
 */
export interface GetFollowingBusinessCategoriesLv2ResponseAllOfData {
    /**
     * フォロー中のビジネスカテゴリの総数
     * @type {number}
     * @memberof GetFollowingBusinessCategoriesLv2ResponseAllOfData
     */
    totalCount: number;
    /**
     * 
     * @type {Array<BusinessCategoryLv2>}
     * @memberof GetFollowingBusinessCategoriesLv2ResponseAllOfData
     */
    businessCategoriesLv2: Array<BusinessCategoryLv2>;
}

export function GetFollowingBusinessCategoriesLv2ResponseAllOfDataFromJSON(json: any): GetFollowingBusinessCategoriesLv2ResponseAllOfData {
    return GetFollowingBusinessCategoriesLv2ResponseAllOfDataFromJSONTyped(json, false);
}

export function GetFollowingBusinessCategoriesLv2ResponseAllOfDataFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetFollowingBusinessCategoriesLv2ResponseAllOfData {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'totalCount': json['total_count'],
        'businessCategoriesLv2': ((json['business_categories_lv2'] as Array<any>).map(BusinessCategoryLv2FromJSON)),
    };
}

export function GetFollowingBusinessCategoriesLv2ResponseAllOfDataToJSON(value?: GetFollowingBusinessCategoriesLv2ResponseAllOfData | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'total_count': value.totalCount,
        'business_categories_lv2': ((value.businessCategoriesLv2 as Array<any>).map(BusinessCategoryLv2ToJSON)),
    };
}

